module.exports = __webpack_public_path__ + "static/media/codeql_logo.a59d6f4b.svg";